/**
 * SellerActivityTimeline.jsx — M6 (Phase 3 Engagement)
 * ====================================================
 * Côté VENDEUR : fil sobre & anonymisé des actions de l'agent sur son bien.
 * Objectif psychologique : le vendeur sent que son bien n'est pas oublié →
 * crédibilise l'agent et réduit le risque de dénonciation.
 */
import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Activity, CheckCircle2 } from 'lucide-react';

function fmt(dateStr) {
    if (!dateStr) return '';
    try {
        return new Date(dateStr).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
    } catch (e) {
        return '';
    }
}

export default function SellerActivityTimeline({ mandateId }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const r = await api.get(`/engagement/seller/timeline?mandate_id=${mandateId}`);
                if (alive) setData(r.data);
            } catch (e) {
                // silencieux
            } finally {
                if (alive) setLoading(false);
            }
        })();
        return () => { alive = false; };
    }, [mandateId]);

    if (loading || !data) return null;

    const events = data.events || [];

    return (
        <div className="rounded-xl bg-card/60 border border-border p-3 mt-2" data-testid="seller-activity-timeline">
            <div className="flex items-center gap-2 mb-2">
                <Activity className="w-3.5 h-3.5 text-[#FF914D]" />
                <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">
                    Actions récentes de votre agent
                </p>
            </div>

            {events.length === 0 ? (
                <p className="text-xs text-muted-foreground" data-testid="seller-timeline-empty">
                    {data.empty_message}
                </p>
            ) : (
                <ul className="space-y-2">
                    {events.map((ev, i) => (
                        <li key={i} className="flex items-start gap-2.5" data-testid="seller-timeline-event">
                            <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 mt-0.5 shrink-0" />
                            <div className="flex-1 min-w-0">
                                <p className="text-xs text-foreground/85 leading-snug">{ev.label}</p>
                            </div>
                            <span className="text-[10px] text-muted-foreground shrink-0">{fmt(ev.date)}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
